import React from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Header from "../../../core/common/header";
import Sidebar from "../../../core/common/sidebar";

const Error404 = () => {
  const routes = all_routes;
  const navigate = useNavigate();

 
  return (
    <>
    
    <div className="page-wrapper vh-100 d-flex flex-column justify-content-between ">

    <div className="container px-6">
      <div className="d-flex align-items-center justify-content-center vh-100">
        <div className="row justify-content-center align-items-center p-4">
          <div className="col-md-6 d-flex justify-content-center align-items-center">
              
              <div>
                <h2 className="mb-3">Oops, something went wrong</h2>
                <p className="fs-14">
                  Error 404 Page not found. Sorry the page you looking for
                  doesn’t exist or has been moved
                </p>
               
              </div>
          </div>
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <div className="error-images">
              <ImageWithBasePath
                src="assets/img/bg/error-404.svg"
                alt="image"
                className="img-fluid"
                style={{width:"80%",height:"50%"}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </>
   
  );
};

export default Error404;
